import { render, staticRenderFns } from "./MyRater.vue?vue&type=template&id=78b66ae0&"
import script from "./MyRater.vue?vue&type=script&lang=js&"
export * from "./MyRater.vue?vue&type=script&lang=js&"
import style0 from "./MyRater.vue?vue&type=style&index=0&id=78b66ae0&prod&lang=scss&"
import style1 from "./MyRater.vue?vue&type=style&index=1&id=78b66ae0&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports